var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',[(_vm.schema && _vm.data)?_c('v-jsf',{ref:"vjsf",attrs:{"schema":_vm.schema},on:{"change":_vm.saveChanges},model:{value:(_vm.filteredData),callback:function ($$v) {_vm.filteredData=$$v},expression:"filteredData"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }